import React, { useEffect, useState } from "react";
import { Mail } from "../../components/Mailbox";
import Dropdown from "react-bootstrap/Dropdown";
import star from "../../assets/images/sarees/star.png";
import { Pagination } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { SareeSubCategory } from "../SareeSubCategory";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import successImg from "../../assets/images/sarees/successImg.png";
import { FaRegHeart } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";

export function Saree() {
  const [currentPage, setCurrentPage] = useState(1);
  const [products, setProducts] = useState([]);
  const [totalCount, setTotalCount] = useState(0); // total number of products from backend

  const [priceMin, setPriceMin] = useState("");
  const [priceMax, setPriceMax] = useState("");
  // const [wishlistedItems, setWishlistedItems] = useState({});
  const [wishlistDisabled, setWishlistDisabled] = useState(false);

  // modal state
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();
  const handlePageChange = (page) => {
    setCurrentPage(page);
    LoadProducts(page);
  };
  async function addtoCart(id) {
    const userId = localStorage.getItem("user_id");
    const Id = id;
    const requestData = {
      userId: userId,
      clothingId: Id,
      quantity: 1,
    };
    try {
      const response = await axiosInstance.post(`/addtocart`, requestData);
      if (response.data.status === 200) {
        toast.success(response.data.message || "Added Successfully");
      } else {
        toast.error("Something went wrong, please try again!");
      }
    } catch (error) {
      console.error("Submission failed:", error);
      toast.error("Submission failed! Please try again.");
    }
  }
  async function handlewishlistClick(e, product) {
    e.stopPropagation();

    const userId = localStorage.getItem("user_id");
    if (wishlistDisabled) return;

    setWishlistDisabled(true); // disable rapid toggling

    try {
      if (product.in_wishlist === 0) {
        // Add to wishlist
        const res = await axiosInstance.post("/admin/insertWishlist", {
          clothing_id: product.id,
          user_id: userId,
        });

        if (res.status === 200) {
          toast.success(res.data.message || "Added to wishlist");

          // Update UI
          setProducts((prev) =>
            prev.map((p) =>
              p.id === product.id ? { ...p, in_wishlist: 1 } : p
            )
          );
        } else {
          toast.error("Something went wrong while adding to wishlist.");
        }
      } else {
        // Remove from wishlist
        const res = await axiosInstance.delete(
          `/admin/deletewishlist/${product.w_id}`
        );

        if (res.status === 200) {
          toast.success(res.data.data || "Removed from wishlist");

          // Update UI
          setProducts((prev) =>
            prev.map((p) =>
              p.id === product.id ? { ...p, in_wishlist: 0 } : p
            )
          );
        } else {
          toast.error("Something went wrong while removing from wishlist.");
        }
      }
    } catch (error) {
      console.error("Wishlist error:", error);
      toast.error("An error occurred. Please try again later.");
    } finally {
      // Re-enable after short delay
      setTimeout(() => setWishlistDisabled(false), 500);
    }
  }

  async function LoadProducts(page) {
    const RequestMethod = {
      type: "1x ",
      price_min: priceMin,
      price_max: priceMax,
      availability: "",
      pageNo: page,
      user_id: localStorage.getItem("user_id") || 0,
    };

    try {
      const response = await axiosInstance.post(
        "/clothingByType",
        RequestMethod
      );
      console.log("saree data", response.data);

      const filteredData = response.data.data.filter(
        (item) => item.active_flag === "A"
      );
      console.log("filtered data", filteredData);

      // Set filtered data to state
      setProducts(filteredData || []);
      setTotalCount(filteredData.length || 0);
    } catch (error) {
      console.error("Error loading products:", error);
    }
  }
  // for reset button
  useEffect(() => {
    if (priceMin === "" && priceMax === "") {
      LoadProducts(1);
    }
  }, [priceMin, priceMax]);

  useEffect(() => {
    LoadProducts(currentPage);
    console.log("totalCount", totalCount);
  }, []);

  return (
    <>
      {/* <ToastContainer /> */}
      <div className="SareeContainer HomeMainContainer container">
        <div className="saree-title">SAREES</div>
        <div className="saree-filter-title">Filter By</div>
        <div className="saree-category-section">
          {/* Availability */}
          {/* <div>
          <Dropdown>
            <Dropdown.Toggle className="dropdown-btn" id="dropdown-basic">
              Availability
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-menu">
              <div
                style={{
                  borderBottom: "1px solid gray",
                  display: "flex",
                  gap: "130px",
                  padding: "5px",
                }}
              >
                <span>0 Selected</span>
                <span>Reset</span>
              </div>
              <div>
                {" "}
                <input type="checkbox" /> In Stock(20)
              </div>
              <div>
                <input type="checkbox" /> Out of stock(20)
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div> */}
          {/* Price */}
          <div>
            <Dropdown>
              <Dropdown.Toggle className="dropdown-btn" id="dropdown-basic">
                Price
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropdown-menu-price">
                <div
                  style={{
                    borderBottom: "1px solid gray",
                    padding: "5px",
                  }}
                >
                  <span>The highest price is Rs. 7,500.00</span>
                  <span
                    className="float-end"
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() => {
                      setPriceMin("");
                      setPriceMax("");
                    }}
                  >
                    Reset
                  </span>
                </div>

                <div className="from-to">
                  <div>
                    ₹{" "}
                    <input
                      type="number"
                      placeholder="From"
                      value={priceMin}
                      onChange={(e) => setPriceMin(e.target.value)}
                    />
                  </div>
                  <div>
                    ₹{" "}
                    <input
                      type="number"
                      placeholder="To"
                      value={priceMax}
                      onChange={(e) => setPriceMax(e.target.value)}
                    />
                  </div>
                </div>
                <Button
                  className="mt-2 mx-2"
                  onClick={() => {
                    setCurrentPage(1);
                    LoadProducts(1); // page 1 with current priceMin and priceMax
                  }}
                >
                  Apply
                </Button>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        {/* cards section */}
        <div className="cards-part">
          {products.map((product) => (
            <div className="saree-card" key={product.id}>
              <div
                className="saree-card-image"
                style={{
                  backgroundImage: `url(${product.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  width: "100%",
                  height: "90%",
                  transition: "background-image 0.3s ease-in-out",
                  position: "relative",
                  borderRadius: "8px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundImage = `url(${product.image_two})`;
                  e.currentTarget.querySelector(
                    ".saree-btnContainer"
                  ).style.display = "flex";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundImage = `url(${product.image})`;
                  e.currentTarget.querySelector(
                    ".saree-btnContainer"
                  ).style.display = "none";
                }}
                onClick={() => {
                  navigate("/sareesubcategory", {
                    state: {
                      Details: product,
                      // isWishlisted: wishlistedItems[product.id] || false,
                    },
                  });
                }}
              >
                <div className="saree-btnContainer">
                  <button
                    className="sree-hoverBtn"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevents bubbling

                      const token = localStorage.getItem("token");

                      if (token) {
                        handleShow();
                        addtoCart(product.id);
                      } else {
                        navigate("/login");
                      }
                    }}
                  >
                    Add To Cart
                  </button>
                </div>

                {/* <div onClick={(e) => handlewishlistClick(e, product)}>
                  {product.in_wishlist === 1 ? (
                    <FaHeart className="wishlist-heart" />
                  ) : (
                    <FaRegHeart className="wishlist-heart" />
                  )}
                </div> */}
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    const token = localStorage.getItem("token");

                    if (!wishlistDisabled) {
                      if (token) {
                        handlewishlistClick(e, product);
                      } else {
                        navigate("/login");
                      }
                    }
                  }}
                  style={{
                    cursor: wishlistDisabled ? "not-allowed" : "pointer",
                    opacity: wishlistDisabled ? 0.5 : 1,
                  }}
                >
                  {product.in_wishlist === 1 ? (
                    <FaHeart className="wishlist-heart" />
                  ) : (
                    <FaRegHeart className="wishlist-heart" />
                  )}
                </div>
              </div>
              <div className="saree-card-title">{product.product_name}</div>
              <div className="saree-card-price">
                <span>₹ {product.price}</span>
                <span style={{ float: "right" }} className="saree-rate">
                  <img src={star} alt="Rating" />
                  {product.average_rating}
                </span>
              </div>
            </div>
          ))}
        </div>
        {/* modal code */}
        <div>
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="addModalheader"></Modal.Header>
            <Modal.Body>
              <div className="successImg">
                <img src={successImg} />
              </div>
              <h3 style={{ textAlign: "center" }}>Added to Cart</h3>
            </Modal.Body>
          </Modal>
        </div>

        <Pagination
          className="custom-pagination"
          current={currentPage}
          pageSize={4}
          total={totalCount} // Total number of products
          onChange={handlePageChange} // Update displayed products
          showSizeChanger={false} // Disable page size changes
        />

        <Mail />
      </div>
    </>
  );
}
